import React, { useState } from "react";

const CapnolearningBrochure = ({
  checkoutsuccessToggleModal,
  setShowForm,
  show,
  setShow,
}) => {
  return (
    <div className="container">
      <div className="p_brochure">
        <div style={{ textAlign: "center" }}>
          <p
            style={{
              fontWeight: "600",
              fontSize: "21px",
              marginBottom: "2px",
            }}
          >
            PROFESSIONAL SCHOOL OF BEHAVIORAL HEALTH SCIENCES
          </p>
          <p
            style={{
              fontWeight: "600",
              fontSize: "21px",
              marginBottom: "2px",
              marginTop: "12px",
            }}
          >
            <em>A Professional Certification Program</em>
          </p>
          <p
            style={{
              fontSize: "26px",
              color: "#383886",
              fontWeight: "600",
              marginBottom: "0px",
            }}
          >
            CapnoLearning<sup>®</sup> Breathing Practitioner
          </p>
          <p
            style={{
              fontSize: "14px",
              marginBottom: "1.5rem",
              fontWeight: "bold",
            }}
          >
            <em>Science, Technology, Applications</em>
            <br />
            Ten learning modules with practicum, 6 academic units, 100 Professional CE hours
          </p>

          <p
            style={{
              fontSize: "14px",
              margin: "0 auto 0px",
              width: "100%",
              textAlign: "start",
            }}
          >
          Statistics suggest that tens of millions of people worldwide suffer with the profound and misunderstood symptoms and deficits of
learned dysfunctional breathing habits that compromise respiration. This compromise is primarily the result of <b>hypocapnia</b>, carbon
dioxide (CO2) deficit, brought about by overbreathing. CapnoLearning brings together respiratory physiology, capnography
technology, and behavioral science for learning to restore optimal respiration, i.e., <b>eucapnia</b>.
          </p>
          <p
            style={{
              fontSize: "14px",
              marginTop: "1rem",
              width: "100%",
              textAlign: "start",
            }}
          >
          The Professional School certifies qualified healthcare practitioners, human service professionals, health educators, and performance
enhancement consultants to help clients learn breathing habits that optimize optimal respiration and balance acid-base physiology.
Candidates learn to use capnography instrumentation for identifying breathing habits that compromise respiration, helping clients
disengage and manage dysfunctional breathing habits, and assisting clients in learning new habits that optimize respiration, i.e., CO2
concentration. The program offers the credential, <b>Certified CapnoLearning<sup>®</sup> Breathing Practitioner</b>.
          </p>
          <p
            style={{
              fontSize: "14px",
              marginTop: "1rem",
              width: "100%",
              textAlign: "start",
            }}
          >
          The one-trimester program includes one live 2-hour orientation session, coursework consisting of ten prerecorded 3 to 4.5-hour
Learning Modules (lectures and demonstrations) with five live 2-hour Q&A sessions, and practicum work consisting of Module
practicum assignments, personal breathing exploration, ten assessment sessions, and ten training sessions with a live 2-hour one-
on-one practicum interview session with Professional School faculty.
          </p>
          <div style={{ padding: "1rem 0" }}>
            <p
              style={{
                fontSize: "14px",
                marginBottom: "0px",
                fontWeight: "600",
              }}
              // onClick={()=>setShowForm(true)}
            >
              Tuition: $2,400.00
            </p>
            <p
              style={{
                fontSize: "14px",
                marginBottom: "0px",
                fontWeight: "600",
              }}
              // onClick={()=>setShowForm(true)}
            >
              Deposit: $300.00
            </p>
            <p
              style={{
                fontSize: "14px",
                marginBottom: "10px",
                fontWeight: "600",
                color: "#383886",
                display: "inline",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => checkoutsuccessToggleModal()}
            >
              CLICK HERE TO REGISTER
            </p>
            <p
              style={{
                fontSize: "13px",
                marginBottom: "1rem",
                marginTop: "0px",
              }}
            >
              OR go to{" "}
              <a href="https://e-campus-registration.bp.edu/" target="_blank">
                www.e-campus.bp.edu
              </a>
            </p>
          </div>
          {!show && (
            <p
              style={{
                fontSize: "14px",
                marginBottom: "2px",
                fontWeight: "600",
                color: "#383886",
                //   display: "inline",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => setShow(!show)}
            >
              CLICK HERE TO READ MORE...
            </p>
          )}

          {show && (
            <p
              style={{
                fontSize: "14px",
                marginBottom: "1rem",
                fontWeight: "600",
                color: "#383886",
                //   display: "inline",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => setShow(!show)}
            >
              CLICK HERE TO HIDE.
            </p>
          )}
        </div>
        {show && (
          <div style={{ padding: "1rem 0 0" }}>
            <p style={{ fontSize: "14px", marginBottom: "1rem" }}>
              <span style={{ color: "#383886", fontWeight: "600" }}>
                Coursework:
              </span>{" "}
              Following completion of each Learning Module, candidates must successfully complete a short multiple-choice quiz before moving
              to the subsequent Module. Candidates meet requirements at their own convenience as they move through the trimester.
            </p>
            <p style={{ fontSize: "14px", marginBottom: "1rem" }}>
              Module 1: Physiology
              <br />
              Module 2: Technology
              <br />
              Module 3: Psychology
              <br />
              Module 4: Interviewing
              <br />
              Module 5: Testing
              <br />
              Module 6: Awareness
              <br />
              Module 7: Self-regulation
              <br />
              Module 8: Applications
              <br />
              Module 9: Demonstrations
              <br />
              Module 10: Business
            </p>
            <p style={{ fontSize: "14px", marginBottom: "1rem" }}>
              <span style={{ color: "#383886", fontWeight: "600" }}>
                Practicum:
              </span>{" "}
              Candidates must have access to CapnoLearning software, e.g., own a CapnoTrainer GO, to complete ten assessment sessions and ten
training sessions with their own volunteer subjects. Candidates document their work by uploading data, session notes, and forms to
the Professional School CapnoLearning database for evaluation by faculty. Each candidate meets for a 2-hour Zoom practicum
evaluation session with a Professional School faculty member.
            </p>
            <p style={{ fontSize: "14px", marginBottom: "1rem" }}>
              <span style={{ color: "#383886", fontWeight: "600" }}>
                Scheduling:
              </span>{" "}
              There is an initial live 2-hour Orientation Session on the first day of the trimester followed by five live 2-hour Q&A Sessions
scheduled on specific dates spread out across the trimester. Recordings of these live sessions are available 24 X 7 on the Professional
School e-campus website. Candidates make appointments for a 2-hour Practicum evaluation interview on the e-campus calendar
website during the last four weeks of the trimester.
            </p>
            <p style={{ fontSize: "14px", marginBottom: "1rem" }}>
            Candidates must complete the Learning Modules on the Professional School e-campus website in a timely fashion, that is, to have
successfully completed a specific set of two Modules before attending its associated Q&A session. Candidates may take Module
quizzes immediately upon completion of a specific Module, although if unsuccessful, the Module must be repeated. Modules move
sequentially from one to the next, each one becoming available only after successful completion of the preceding quiz.
            </p>

            <p style={{ fontSize: "14px", marginBottom: "1rem" }}>
              <span style={{ color: "#383886", fontWeight: "600" }}>
                Admission:
              </span>{" "}
              resume and documents
              <br />
              <b>Resume</b>: include formal education and experience in healthcare, human service, or performance training
              <br />
              <b>Documents</b>: include higher education transcripts and copies of certifications and licenses
            </p>
            <p style={{ fontSize: "14px", marginBottom: "1rem" }}>
              <span style={{ color: "#383886", fontWeight: "600" }}>
                Registration:
              </span>{" "}
              website and email
              <br />
              Go to:{" "}
              <a href="https://e-campus-registration.bp.edu/" target="_blank">
                www.e-campus.bp.edu
              </a>
              . Email: <a href="mailto:education@bp.edu">education@bp.edu</a>
              <br />
            </p>

            <div
              style={{
                textAlign: "center",
                background: "#f9ebeaad",
                padding: "10px",
              }}
            >
              <p
                style={{
                  fontSize: "14px",
                  marginBottom: "0px",
                  fontWeight: "600",
                }}
                // onClick={()=>setShowForm(true)}
              >
                Tuition: coursework and practicum
                <br />
                $2,400.00
              </p>
              <p
                style={{
                  fontSize: "14px",
                  marginBottom: "0px",
                  fontWeight: "600",
                }}
                // onClick={()=>setShowForm(true)}
              >
                Deposit:
                $300.00
              </p>
              <p
                style={{
                  fontSize: "14px",
                  marginBottom: "10px",
                  fontWeight: "600",
                  color: "#383886",
                  display: "inline",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={() => setShowForm(true)}
              >
                CLICK HERE TO REGISTER
              </p>
              <p
                style={{
                  fontSize: "13px",
                  marginBottom: "1rem",
                  marginTop: "0px",
                }}
              >
                OR go to{" "}
                <a href="https://e-campus-registration.bp.edu/" target="_blank">
                  www.e-campus.bp.edu
                </a>
              </p>

              <p
                style={{
                  fontSize: "12px",
                  marginBottom: "2px",
                  fontWeight: "bold",
                  color: "#383886",
                }}
              >
                Behavioral Breathing Sciences
              </p>
              <p
                style={{
                  fontSize: "13.5px",
                  marginBottom: "0px",
                  fontWeight: "bold",
                }}
              >
                PROFESSIONAL SCHOOL OF BEHAVIORAL HEALTH SCIENCES
              </p>
              <p
                style={{
                  fontSize: "15px",
                  marginBottom: "0",
                }}
              >
                Professional Diploma, Certificate, and Certification programs
              </p>
              <p
                style={{
                  fontSize: "13px",
                  marginBottom: "2rem",
                  //   marginTop: "2rem",
                }}
              >
                <a href="mailto:education@bp.edu">education@bp.edu</a>{" "}
                307.633.9800
              </p>

              {show && (
                <p
                  style={{
                    fontSize: "14px",
                    marginBottom: "1rem",
                    fontWeight: "600",
                    color: "#383886",
                    //   display: "inline",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  onClick={() => setShow(!show)}
                >
                  CLICK HERE TO HIDE.
                </p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CapnolearningBrochure;
